module.exports = __webpack_public_path__ + "img/family.75936aa3.jpg";